import React from 'react';
import PropTypes from 'prop-types';
import Lazyload from 'react-lazyload';
// import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';

import './LazyLoadTransition.scss';

export const LazyLoadTransition = ({ children }) => (
  <Lazyload height={120} throttle={0}>
    <CSSTransitionGroup
      transitionAppear
      transitionAppearTimeout={250}
      transitionEnter={false}
      transitionLeave={false}
      transitionName="fade">
      {children}
    </CSSTransitionGroup>
  </Lazyload>
);

LazyLoadTransition.propTypes = {
  children: PropTypes.node.isRequired
};

export default LazyLoadTransition;
